import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';

import {
	LandingHeading,
	LandingTextGrid,
	LandingTextGridItem,
	LandingSection,
	LandingDescription,
} from '@tempo/landing';

export const FeatureInfo: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['hifi']});
	return (
		<LandingSection isContained data-testid="hifi-featureinfo-section">
			<LandingDescription textAlign="center">
				<LandingHeading as="h2">
					{t('deezerhifilandingpage_title_whatdoeshifimean_web')}
				</LandingHeading>
				<LandingTextGrid>
					<LandingTextGridItem title={t('generic_title_highfidelitysound_web')}>
						{t('deezerhifilandingpage_text_listenflacmusicinhifisound_web')}
					</LandingTextGridItem>
					<LandingTextGridItem
						title={t('deezerfamilylandingpage_title_crossdevicelistening_web')}
					>
						{t(
							'deezerhifilandingpage_text_streamflacmusicaccrossalldevices_web',
						)}
					</LandingTextGridItem>
					<LandingTextGridItem
						title={t('generic_title_millionofflactracks_web')}
					>
						{t('sonyredeemcodepage_text_expansivecatalogflactracks_web')}
					</LandingTextGridItem>
					<LandingTextGridItem
						title={t('generic_title_highendsoundsystemcompatibility_web')}
					>
						{t('sonyredeemcodepage_text_enjoycristalclearmusic_web')}
					</LandingTextGridItem>
					<LandingTextGridItem
						title={t('deezerhifilandingpage_title_featuresincludedinhifi_web')}
					>
						{t('deezerhifilandingpage_text_accesshifiroomgetimmersed_web')}
					</LandingTextGridItem>
				</LandingTextGrid>
			</LandingDescription>
		</LandingSection>
	);
};
